import { useContext } from 'react';
import { MarketContext } from './market-context';

export function useMarketConfig() {
	const ctx = useContext(MarketContext);
	return ctx;
}
